import { render, staticRenderFns } from "./ElectronicAlert.vue?vue&type=template&id=a32fa67e&"
import script from "./ElectronicAlert.vue?vue&type=script&lang=js&"
export * from "./ElectronicAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports